import { useAsync } from 'react-async'

/**
 * Very thin wrapper around react-async's `useAsync` hook. API is exactly the same.
 * Only provides a `debugLabel` option to avoid defining every time.
 */
export function useAPI<T = any>(arg1, arg2?: any) {
  const options =
    typeof arg1 === 'function' ? { ...arg2, promiseFn: arg1 } : arg1
  const optsWithLabel = {
    ...options,
    debugLabel: options.promiseFn.name,
  }
  return useAsync<T>(optsWithLabel)
}
